const METADATA_TIMEOUT = 5000;

// <video> 엘리먼트는 오디오 파일의 메타데이터도 로드할 수 있음
export const getMediaDuration = (url: string): Promise<number | null> =>
  new Promise((resolve) => {
    const video = document.createElement('video');
    video.preload = 'metadata';

    const timer = setTimeout(() => {
      cleanup();
      resolve(null);
    }, METADATA_TIMEOUT);

    const cleanup = () => {
      clearTimeout(timer);
      video.removeAttribute('src');
      video.load();
    };

    video.addEventListener('loadedmetadata', () => {
      // cleanup의 load() 호출이 엘리먼트를 리셋해 duration이 NaN이 되므로 먼저 읽음
      const duration = video.duration;
      cleanup();
      resolve(Number.isFinite(duration) ? duration : null);
    });

    video.addEventListener('error', () => {
      cleanup();
      resolve(null);
    });

    video.src = url;
  });
